import { Stack, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { CreditScore } from './Filters.components';
import { FormField } from './FormField';
import { useCreditsData } from '../hooks';
import { useTableCheckIds } from '../store';
import { UserMapping } from './UserMapping';

export const ManageCredit = (): ReactElement => {
  const data = useCreditsData();
  const checked = useTableCheckIds();

  return (
    <Stack>
      {checked.length <= 1 && (
        <Stack direction="row" justifyContent="center" alignItems="center">
          <Stack direction="row" gap={2} alignItems="center">
            <svg
              width="67"
              height="67"
              viewBox="0 0 67 67"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M66.0418 33.5C66.0418 43.3957 61.625 52.2618 54.6523 58.2317C48.763 63.2818 41.2582 66.0528 33.5002 66.0417C25.4239 66.0417 18.037 63.1011 12.3481 58.2317C8.77309 55.1791 5.90328 51.3868 3.93685 47.1169C1.97043 42.8469 0.954255 38.201 0.958509 33.5C0.958509 15.5282 15.5283 0.958374 33.5002 0.958374C51.472 0.958374 66.0418 15.5282 66.0418 33.5ZM45.3335 23.1459C45.3335 20.0075 44.0868 16.9976 41.8676 14.7784C39.6484 12.5593 36.6386 11.3125 33.5002 11.3125C30.3618 11.3125 27.3519 12.5593 25.1327 14.7784C22.9136 16.9976 21.6668 20.0075 21.6668 23.1459C21.6668 26.2843 22.9136 29.2941 25.1327 31.5133C27.3519 33.7325 30.3618 34.9792 33.5002 34.9792C36.6386 34.9792 39.6484 33.7325 41.8676 31.5133C44.0868 29.2941 45.3335 26.2843 45.3335 23.1459ZM52.7293 51.9157V51.25C52.7293 48.1116 51.4826 45.1018 49.2634 42.8826C47.0443 40.6634 44.0344 39.4167 40.896 39.4167H26.1043C22.9659 39.4167 19.9561 40.6634 17.7369 42.8826C15.5177 45.1018 14.271 48.1116 14.271 51.25V51.9157C14.8824 52.5527 15.5234 53.1591 16.1939 53.735C21.0114 57.8686 27.1524 60.136 33.5002 60.125C37.0945 60.1319 40.6527 59.4077 43.9584 57.9964C47.2641 56.5851 50.2482 54.5163 52.7293 51.9157Z"
                fill="#CBCACA"
              />
            </svg>
            <Stack gap={1}>
              <Typography fontSize={16} fontWeight={700}>
                Cooper, Tommy
              </Typography>
              <CreditScore>
                <svg
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.5675 8.2775C14.2765 8.54182 14.9074 8.98065 15.4018 9.5534C15.8963 10.1261 16.2383 10.8143 16.3963 11.5543C16.5543 12.2943 16.5232 13.0621 16.3058 13.7869C16.0884 14.5116 15.6918 15.1699 15.1526 15.7007C14.6134 16.2316 13.949 16.6179 13.221 16.8239C12.4929 17.03 11.7247 17.0491 10.9873 16.8796C10.2498 16.7101 9.56709 16.3573 9.00212 15.854C8.43716 15.3507 8.00823 14.713 7.755 14M5.25 5H6V8M12.5325 10.91L13.0575 11.4425L10.9425 13.5575M10.5 6.5C10.5 8.98528 8.48528 11 6 11C3.51472 11 1.5 8.98528 1.5 6.5C1.5 4.01472 3.51472 2 6 2C8.48528 2 10.5 4.01472 10.5 6.5Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <Typography fontSize={14} fontWeight={700}>
                  342
                </Typography>
              </CreditScore>
            </Stack>
          </Stack>
        </Stack>
      )}
      <FormField />
      <UserMapping />
    </Stack>
  );
};
